import { styled } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import FullPageCircularProgress from "components/full-page-circular-progress";
import { brand } from "../../theme";

export const CircularProgress = FullPageCircularProgress;

export const Container = styled("div")({
    background: brand.surface,
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
});

export const SearchBar = styled("div")(({ theme }) => ({
    padding: theme.spacing(1.5, 2, 0.5),
    background: brand.surface,
    position: "sticky",
    top: 0,
    zIndex: 5,
}));

export const SearchField = styled(({ value, onChange, className }) => (
    <div className={className}>
        <SearchIcon className="icon" />
        <input
            placeholder="Search tasters"
            value={value}
            onChange={onChange}
        />
    </div>
))({
    position: "relative",
    "& .icon": {
        position: "absolute",
        left: 12,
        top: "50%",
        transform: "translateY(-50%)",
        color: brand.textDis,
        fontSize: 16,
    },
    "& input": {
        width: "100%",
        height: 38,
        border: "none",
        borderRadius: 10,
        background: brand.white,
        padding: "0 12px 0 34px",
        fontSize: 14,
        color: brand.text,
        outline: "none",
        boxShadow: `inset 0 0 0 1px ${brand.sep}`,
        fontFamily: "inherit",
    },
});

export const CountHint = styled("div")(({ theme }) => ({
    padding: theme.spacing(0.75, 2.5, 0.5),
    fontSize: 11,
    fontWeight: 700,
    color: brand.textSec,
    letterSpacing: 0.8,
    textTransform: "uppercase",
}));

export const ListWrap = styled("div")({
    background: brand.white,
    "& .MuiList-root": {
        padding: 0,
    },
});

export const EmptyMessage = styled("div")(({ theme }) => ({
    padding: theme.spacing(7.5, 4),
    textAlign: "center",
    color: brand.textSec,
    fontSize: 14,
}));
